import { render } from "./StudentSocialPaymentView.vue?vue&type=template&id=7e4ad086&scoped=true"
import script from "./StudentSocialPaymentView.vue?vue&type=script&lang=js"
export * from "./StudentSocialPaymentView.vue?vue&type=script&lang=js"

import "./StudentSocialPaymentView.vue?vue&type=style&index=0&id=7e4ad086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4ad086"]])

export default __exports__